import { useState } from "react";
import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { Plus } from "lucide-react";
import PlanEditorDrawer from "./PlanEditorDrawer";

interface Props {
  integrationId: string;
  category?: string;
  categories?: string[];
  onCreated: (planId: string) => void;
}

// A "New plan" button that opens the create-plan drawer in place and reports
// the new plan's id, so a plan can be created without leaving the current page
// (used from the playbook entries table and the nested-plan step editor).
const InlinePlanCreate = ({ integrationId, category, categories, onCreated }: Props) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        size="sm"
        variant={ButtonVariant.SecondaryGray}
        leftIcon={<Plus size={14} />}
        onClick={() => setOpen(true)}
      >
        New plan
      </Button>
      {open && (
        <PlanEditorDrawer
          integrationId={integrationId}
          category={category}
          categories={categories}
          onClose={() => setOpen(false)}
          onCreated={(planId) => {
            setOpen(false);
            if (planId) onCreated(planId);
          }}
        />
      )}
    </>
  );
};

export default InlinePlanCreate;
